<ng-container *transloco="let t;">

  <div class="card p-mb-4" [ngClass]="{'card-disabled': disabled === true }">
    <p [innerHtml]="texts.orderform_template_before"></p>

    <div class="p-grid">
      <div class="p-col-4">
        <app-form-control [cid]="'template'" [control]="form.get('template.base.template')" [type]="'select'" [options]="templates" [filter]="true" [label]="t('common.labels.ac_type')"></app-form-control>
        <ng-container *ngIf="tagVisible">
          <app-form-control [cid]="'tags'" [control]="form.get('template.add.tags')" [type]="'multiselect'" [options]="tags" [label]="tagLabel"></app-form-control>
          <p *ngIf="tagDescription !== null" class="p-mt-0" [innerHtml]="tagDescription | nl2br"></p>
        </ng-container>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'location'" [control]="form.get('template.base.location')" [type]="'select'" [options]="locations" optionLabel="name" [label]="t('common.labels.location')"></app-form-control>
      </div>
    </div>

    <div class="p-grid" *ngIf="lqgPositionVisible === true">
      <div class="p-col-8">
        <app-form-control [cid]="'lqgposition'" [control]="form.get('template.add.lqgposition')" [type]="'select'" [options]="options.lqg_positions" [label]="t('common.labels.lqgposition')"></app-form-control>
      </div>
    </div>

    <div class="disabled-screen"><i class="pi pi-lock"></i></div>

  </div>

  <p-dialog [header]="texts.orderform_template_virtualinfo_title" [(visible)]="virtualInfoVisible" [modal]="true" [style]="{width: '70vw', 'max-width': '680px'}" [closeOnEscape]="false" [closable]="false">
    <p [innerHtml]="texts.orderform_template_virtualinfo_content"></p>
    <ng-template pTemplate="footer">
      <div class="p-text-center">
        <button pButton (click)="acceptVirtualInfo()" type="button" aria-label="{{ t('orderform.buttons.virtual_info_accept') }}" [label]="t('orderform.buttons.virtual_info_accept')"></button>
        <button pButton (click)="declineVirtualInfo()" type="button" aria-label="{{ t('orderform.buttons.virtual_info_decline') }}" [label]="t('orderform.buttons.virtual_info_decline')" class="p-button-secondary p-button-outlined"></button>
      </div>
    </ng-template>
  </p-dialog>

</ng-container>
